import NeoTooltip from 'design/design_components/neo/overlay/NeoTooltip.base';

export default function InfoTooltip(props) {
  return (
    <>
      {
        (props.label) &&
        <span style={{ marginRight: '0.3em' }}>{props.label}</span>
      }
      <i className={`pi pi-${props.icon ? props.icon : "question-circle "} ${props.id}-info`} style={{ paddingLeft: props.pl ?? '0' }} />
      <NeoTooltip  {...props} target={`.${props.id}-info`} position={props.position ? props.position : 'bottom'}>
        {props.body ?? props.children}
      </NeoTooltip>
    </>
  );
}